var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCalendarLines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "calendar-lines",
    d: "M15.042,1.583H14.25V.792a.792.792,0,0,0-1.583,0v.792H6.333V.792a.792.792,0,0,0-1.583,0v.792H3.958A3.963,3.963,0,0,0,0,5.542v9.5A3.963,3.963,0,0,0,3.958,19H15.042A3.963,3.963,0,0,0,19,15.042v-9.5A3.963,3.963,0,0,0,15.042,1.583ZM3.958,3.167H15.042a2.378,2.378,0,0,1,2.375,2.375v.792H1.583V5.542A2.378,2.378,0,0,1,3.958,3.167Zm11.083,14.25H3.958a2.378,2.378,0,0,1-2.375-2.375V7.917H17.417v7.125A2.378,2.378,0,0,1,15.042,17.417Zm0-6.333a.791.791,0,0,1-.792.792H4.75a.792.792,0,1,1,0-1.583h9.5A.791.791,0,0,1,15.042,11.083ZM9.5,14.25a.791.791,0,0,1-.792.792H4.75a.792.792,0,1,1,0-1.583H8.708A.791.791,0,0,1,9.5,14.25Z",
    fill: "#040227"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarLines);
export default __webpack_public_path__ + "static/media/icon-calendar-lines.97d7881256ec20c8da508d390eb7c563.svg";
export { ForwardRef as ReactComponent };